import axios from 'axios'

export default class Municipio {
  constructor (tokenBearer, url, codigoUnimed, codigoEstado, municipio, codigoIbge) {
    this.url = `${url}/api/unimed/areaAcao/novosmunicipios/${codigoUnimed}?estadoId=${codigoEstado}&nomeMunicipio=${municipio}&municipioId=${codigoIbge}`
    this.tokenBearer = tokenBearer
  }

  getMunicipios () {
    return new Promise(async (resolve, reject) => {
      let optionsMunicipios = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseMunicipios = await axios(optionsMunicipios)
        resolve(responseMunicipios)
      } catch (err) {
        reject(err)
      }
    })
  }
}
